import * as React from 'react';
// import BScroll from 'better-scroll';
import * as queryString from 'query-string';
import * as moment from 'moment';
import config from '../../../server/config';
import request from '../../../server/request';
// import store from '@/redux/index';

export default class AuthApplyList extends React.Component<any, any> {
    private page: number = 1;
    private isLoading: boolean = false;
    private loadOver: boolean = false;
    // private bsScrollCollection: any[] = [];
    public constructor(props: any) {
        super(props);
        const query = queryString.parse(this.props.location.search);
        this.state = {
            init: true, // 是否第一次进页面
            type: query.type,
            list: [], // 列表数据
        };
    }
    public componentDidMount() {
        window.addEventListener('scroll', this.scrollAction.bind(this));
        this.getData();
        // const items = document.querySelectorAll('.apply-item');
        // items.forEach((v: any) => {
        //     const bscroll = new BScroll(v ,{
        //         scrollX: true,
        //         click: true,
        //         bounce: false
        //     });
        //     bscroll.on('touchEnd', e => {
        //         const scrollDistCenter = window.innerWidth * .611 * .2305;
        //         if(Math.abs(e.x) > scrollDistCenter) {
        //             bscroll.scrollTo(-scrollDistCenter * 2, 0, 500);
        //         } else {
        //             bscroll.scrollTo(0, 0, 500);
        //         }
        //     });
        //     this.bsScrollCollection.push(bscroll);
        // });
    }
    public componentWillUnmount() {
        document.body.style.backgroundColor = '';
        this.page = 1;
        this.isLoading = false;
        this.loadOver = false;
        // this.bsScrollCollection = [];
        window.removeEventListener('scroll', this.scrollAction.bind(this));
    }
    public render() {
        const state = this.state;
        return (
            !state.init ?
                <div className="apply-list">
                {
                    state.list.length === 0 ? 
                    <div className="upgrade">
                        <div className="upgrade-top"><img src={require('../../../assets/images/nothing.png')} /><p>您没有任何申请</p></div>
                    </div>
                    :
                    <div className="apply-list-content">
                        <ul className="mui-table-view">
                            {
                                state.list.map((v: any, k: number) => {
                                    return (
                                        <li key={`recordItem${k}`}>
                                            <p className="mui-date">{moment(v.applyTime).format('YYYY-MM-DD HH:mm:ss')}</p>
                                            <div className="apply-item">
                                                <div className="apply-item-content">
                                                    <div className="mui-slider-handle">   
                                                        <dl>
                                                            <dt>公司名称</dt>
                                                            <dd>{v.companyName}</dd>
                                                        </dl>
                                                        {
                                                            state.type !== 1 ?
                                                            <dl>
                                                                <dt>公司代码</dt>
                                                                <dd>{v.licenseNumber}</dd>
                                                            </dl>
                                                            : null
                                                        }
                                                        <dl>
                                                            <dt>申请人</dt>
                                                            <dd>{v.member}</dd>
                                                        </dl>
                                                        <dl>
                                                            <dt>审核状态</dt>
                                                            <dd>{['待审核', '通过', '不通过'][v.status]}</dd>
                                                        </dl>
                                                    </div>
                                                    <div className="item-delete" onClick={() => this.deleteItemAction()}><img src={require('../../../assets/images/trash.png')} /></div>
                                                </div>
                                            </div>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                        <div className="purchaseloading">{ this.loadOver ? null : <img src={require('../../../assets/images/gif.gif')} /> }<span>{this.loadOver ? '没有更多数据' : '正在加载...'}</span></div>
                    </div>
                }
            </div>
            : null
        )
    }
    // 加载页面数据
    private async getData() {
        this.isLoading = true;
        const r = await request({
            data: {
                pageNum: this.page,
                pageSize: 10,
                type: this.state.type
            },
            url: `${config.API}member/company/apply/recode/my/page`
        });
        this.isLoading = false;
        if(r.code === 1) {
            if(r.obj.list && r.obj.list.length > 0) {
                document.body.style.backgroundColor = '#efeff4';
                if(r.obj.pageNum >= r.obj.pages) {
                    this.loadOver = true;
                }
                this.setState({
                    init: false,
                    list: [...this.state.list, ...r.obj.list]
                });
            } else {
                this.loadOver = true;
                this.setState({
                    init: false
                });
            }
            
        }
    }
    // 加载更多
    private scrollAction() {
        if(window.pageYOffset + window.innerHeight - 100 > document.body.offsetHeight) {
            this.loadMore();
        }
    }
    // 加载更多处理
    private loadMore() {
        if(this.isLoading || this.loadOver) {
            return;
        }
        this.page ++;
        this.getData();
    }
    private deleteItemAction() {

    }
}